import Vue from 'vue'
import Vuex from 'vuex'
import { putRedis, getRedis, removeRedis } from '@/common/redis';

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		sys: {},
		hasLogin: false,
		userInfo: {
			head: '',
			mobile: '',
			nickname: '',
			token: ''
		},
		token: ''
	},
	mutations: {
		setUserInfo(state, user) {
			state.hasLogin = true;
			state.token = user.token;
			state.userInfo = user;
			putRedis('userInfo', user, 60 * 60 * 24 * 15);
		},
		login(state, user) {
			state.hasLogin = true;
			state.token = user.token;
			state.userInfo = user;
			putRedis('userInfo', user, 60 * 60 * 24 * 15);
		},
		logout(state) {
			console.log('logout');
			state.hasLogin = false;
			state.userInfo = {

			};
			state.token = '';
			const removeList = ['userInfo', "token", 'tokenredis', 'collectStorge', 'pKey'];
			removeRedis('userInfo');
			removeList.forEach(name => {
				window.localStorage.removeItem({
					key: name
				});
			})
		},
		setSys(state, info) {
			state.sys = info
		}
	},
	actions: {
	},
	modules: {
	}
})
